import {Directive, forwardRef, Inject} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {
  isValidNationalRegisterNumber,
  NationalRegisterNumber,
  NationalRegisterNumberFormatter,
} from '@atlas/businesstypes';

import {
  ATLAS_VALUE_ACCESSOR,
  AtlasControlValueAccessor,
  BaseBusinesstypeDirective,
} from '../base/index';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasNationalRegisterNumber]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => NationalRegisterNumberDirective),
    },
  ],
})
export class NationalRegisterNumberDirective extends BaseBusinesstypeDirective {
  public constructor(@Inject(ATLAS_VALUE_ACCESSOR) input: AtlasControlValueAccessor) {
    super(input);
  }

  public writeValue(value?: NationalRegisterNumber | string): void {
    this._input.writeValue(
      NationalRegisterNumber.isNationalRegisterNumber(value)
        ? NationalRegisterNumberFormatter.format(value)
        : value == null
        ? ''
        : value,
    );
  }

  public registerOnChange(fn: (_: NationalRegisterNumber | string | null) => void): void {
    this._input.registerOnChange(value => {
      if (value === '') {
        fn(null);
        return;
      }

      const unformatted = NationalRegisterNumberFormatter.unformat(value);
      fn(
        isValidNationalRegisterNumber(unformatted)
          ? new NationalRegisterNumber(unformatted)
          : unformatted,
      );
    });
  }
}
